import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import ReportComponentsMenu from "./report-components-menu";
import { getValue } from "store/languages";

let mapStateToProps = (state) => {
    return {
        reportTemplates: state.ReportConstructor.reportTemplates,
        isReportsUpdated: state.ReportConstructor.isReportsUpdated,
        reportComponents: state.ReportConstructor.reportComponents,
        selectedReportTemplate: state.ReportConstructor.selectedReportTemplate,
        selectedLanguage: state.languages.selectedLanguage,
        isReadOnly: state.ReportConstructor.isReadOnly
    }
}

const ReportComponentsMenuContainer = (ReportComponentsMenu);

export default compose(
    connect(
        mapStateToProps, {
            getValue
        }
    )
) (ReportComponentsMenuContainer)
